"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterOfPoisonsEffectHandler = exports.MasterOfPoisonsEffectArgs = void 0;
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class MasterOfPoisonsEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.MasterOfPoisons;
        this.__typeName = "MasterOfPoisons";
        this.name = "MasterOfPoisons";
        this.harmful = false;
    }
}
exports.MasterOfPoisonsEffectArgs = MasterOfPoisonsEffectArgs;
MasterOfPoisonsEffectArgs.CustomText = "Attacks poison targets.";
let MasterOfPoisonsEffectHandler = class MasterOfPoisonsEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehId = container.registerEventHandlerScript(state.targetId, EventType_1.EventType.DamageDealt, Schedule_1.Schedule.Unlimited, "Effect_MasterOfPoisons_OnDamageDealt", {});
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.ehId);
    }
};
MasterOfPoisonsEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.MasterOfPoisons)
], MasterOfPoisonsEffectHandler);
exports.MasterOfPoisonsEffectHandler = MasterOfPoisonsEffectHandler;
